// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.streams-drawer-standard-setup {
  max-width: 584px;
}
.streams-drawer-standard-setup .horizontal-rule {
  background-color: #bec3c7;
  width: 100%;
  height: 1px;
}
.streams-drawer-standard-setup .stream-suggestion .cu-text-link-primary.disabled-suggestion {
  color: #adb3b8 !important;
  cursor: not-allowed !important;
}
.streams-drawer-standard-setup .stream-suggestion .cu-text-link-primary.disabled-suggestion:hover {
  text-decoration: none !important;
}
`, "",{"version":3,"sources":["webpack://./app/streams-drawer/streams-drawer-standard-setup/streams-drawer-standard-setup.less"],"names":[],"mappings":"AAEA;EACE,gBAAA;AADF;AAAA;EAII,yBAAA;EACA,WAAA;EACA,WAAA;AADJ;AALA;EAWM,yBAAA;EACA,8BAAA;AAHN;AAKM;EACE,gCAAA;AAHR","sourcesContent":["@import (reference) '../../../css/unison';\n\n.streams-drawer-standard-setup {\n  max-width: @cu-wide-measure;\n\n  .horizontal-rule {\n    background-color: @cu-gray-4;\n    width: 100%;\n    height: 1px;\n  }\n\n  .stream-suggestion {\n    .cu-text-link-primary.disabled-suggestion {\n      color: @cu-gray-5 !important;\n      cursor: not-allowed !important;\n\n      &:hover {\n        text-decoration: none !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
